import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { MovimientosInventarioController } from './movimientos-inventario.controller';
import { MovimientosInventarioService } from './movimientos-inventario.service';

@Module({
  imports: [PrismaModule],
  controllers: [MovimientosInventarioController],
  providers: [MovimientosInventarioService],
  exports: [MovimientosInventarioService],
})
export class MovimientosInventarioModule {}
